const loadGoogleAd = () => {
    let adInfoArry = [];
    let googleAdPageData = (window?.pageData && window.pageData?.googlead) ? window.pageData.googlead : {};
    if (document.querySelectorAll('.ad-block').length > 0) {
        document.querySelectorAll('.ad-block').forEach(function(node) {
            let adInfoObj = {};
            adInfoObj['adId'] = node?.getAttribute('id');
            adInfoObj['slotId'] = node?.getAttribute('slotId');
            adInfoObj['className'] = node?.getAttribute('className');
            adInfoArry.push(adInfoObj);
        });
    }
    if (googleAdPageData?.isGoogleAdEnabled === 'true' && adInfoArry.length > 0) {
        processAdRequest(adInfoArry, googleAdPageData);// added condition to check if googleAd is enabled or not
    }
}
 
const processAdRequest = (adInfoArry, googleAdPageData) => {
    try {
        let adSlots = [];
        let isLogKeyValueEnabled = googleAdPageData?.logKeyvalueEnabled === 'true' ? true : false;
        let isAdLazyLoadingEnabled = googleAdPageData?.isAdLazyLoadingEnabled === 'true' ? true : false;
        googletag.cmd.push(function () {
            if (adSlots && adSlots.length > 0) {
                googletag.destroySlots(adSlots);
                adSlots = [];
            }
            logAdEventsInAmplitude('adBlocker');
            //below is Payment adPath
            adInfoArry.map(function(adObj) {
                let responsiveAdSlot = googletag
                .defineSlot(adObj?.slotId, [
                    [728, 90],
                    [320, 50]], adObj?.adId
                )
                .addService(googletag.pubads());
                let mapping = googletag
                    .sizeMapping()
                    .addSize([990, 0], [728, 90])
                    .addSize([0, 0], [320, 50])
                    .build();
                responsiveAdSlot.defineSizeMapping(mapping);
                if (!responsiveAdSlot) {
                    // Error handled silently for security
                    return;
                }
                if (isNonProdEnv(window.location.host)) {
                   googletag.pubads().setTargeting('env', 'test');
                }
                if (consentForNonPersonalizedAds(googleAdPageData)) {
                    googletag.pubads().setPrivacySettings({ nonPersonalizedAds: true });
                }
                if (isLogKeyValueEnabled) {
                    logKeyValueForAds();
                }
                if (isAdLazyLoadingEnabled) {
                    //Enable lazy laoding
                    googletag.pubads().enableLazyLoad({
                        // Fetch slots within 2 viewports.
                        fetchMarginPercent: 200,
                        // Render slots within 1 viewports.
                        renderMarginPercent: 100,
                        // Double the above values on mobile, where viewports are smaller
                        // and users tend to scroll faster.
                        mobileScaling: 2.0,
                    });
                }
                googletag.pubads().enableSingleRequest();
                googletag.enableServices();
                logAdEventsInAmplitude('init');
                adSlots.push(responsiveAdSlot);
                if (typeof PWT.requestBids === "function") {
                    PWT.initAdserverSet = false;
                    PWT.requestBids(
                    PWT.generateConfForGPT(googletag.pubads().getSlots()),
                    function (adUnitsArray) {
                        PWT.addKeyValuePairsToGPTSlots(adUnitsArray);
                        displayAd(adObj, true, adUnitsArray?.length > 0);
                    }
                    );
                } else {
                    displayAd(adObj, false);
                }
            }); 
        });
    } catch (e) {
        // Error handled silently for security
    }
}

const displayAd = (adObj, pwtReq, pwtResp) => {
    try {
        if (PWT.initAdserverSet) return;
        PWT.initAdserverSet = true;
        if (adObj?.adId) {
            googletag.display(adObj.adId);
            PWT.initAdserverSet = false;
            logAdEventsInAmplitude('load', pwtReq, pwtResp, adObj);
        }
    } catch (e) {
        // Error handled silently for security
    }
}

const logAdEventsInAmplitude = (evetProperty, pwtReq, pwtResp, adObj) => {
    try {
        let ampObj = {};
        if (evetProperty) {
            switch(evetProperty) {
                case 'adBlocker': 
                    const adBlocked = window.PWT === undefined;
                    ampObj['ad_blocker_opted'] = adBlocked ? 'Yes' : 'No';
                    triggerAmplitudeLogEvent('ad_load_performance',ampObj);
                break;
                case 'init':
                    ampObj['ad_initialized'] = 'Yes';
                    triggerAmplitudeLogEvent('ad_load_performance',ampObj);
                break;
                case 'click':
                    ampObj['ad_clicked'] = 'Yes';
                    triggerAmplitudeLogEvent('ad_load_performance',ampObj);
                break;    
                case 'load':
                    googletag.pubads().addEventListener("slotRenderEnded", (event) => {
                        setTimeout(function () {
                                let isAdAvailable = (!event?.isEmpty && event?.size[0] != 1) ? 'Yes' : 'No';
                                if (window.PWT) {
                                    ampObj['pubmatic_request'] = pwtReq ? 'Yes' : 'No';
                                    ampObj['pubmatic_response'] = pwtResp ? 'Yes' : 'No';
                                }
                                ampObj['ad_loaded'] = isAdAvailable;
                                triggerAmplitudeLogEvent('ad_load_performance',ampObj);
                                if (isAdAvailable === 'Yes') {
                                    let adClassEle = document.getElementsByClassName('ad-block')?.[0];
                                    if (adClassEle) {
                                        let customClass = adObj?.className || "";
                                        if (customClass !== "") {
                                            let classesToAdd = customClass.split(",");
                                            adClassEle.classList.add(...classesToAdd);
                                        }
                                    }
                                    registerClickEvent(adObj?.adId);
                                }
                        }, 1000)
                    });
                break;    
            }
        }
    } catch (e) {
        // Error handled silently for security
    }
}

const isNonPersonalizedAd = (personalizedAdCookie) => {
   try {
    if (personalizedAdCookie.length > 0) {
        const personalizedAdCookies = personalizedAdCookie.split(',');
        if(CookieService.getCookie('userCookieOptIn')) {
            const userconsentforPersonalizedAd = personalizedAdCookies.every((item) => {
                return CookieService.getCookie('userCookieOptIn').includes(item)
            })
            return !userconsentforPersonalizedAd;
        }
      return false;
    }
   } catch (e) {
      // Error handled silently for security
   }
}

const  registerClickEvent = (divId) => {
    try {
        const slotElement = document.getElementById(divId);
        if (slotElement && slotElement.getElementsByTagName("iframe") && slotElement.getElementsByTagName("iframe").length > 0) {
            const iframeContent = slotElement.getElementsByTagName("iframe")[0];
            if (iframeContent && iframeContent.contentWindow && iframeContent.contentWindow.document && iframeContent.contentWindow.document.body) {
                const iframeBody = iframeContent.contentWindow.document.body;
                if (iframeBody != null) {
                    const iframeBannerElements = iframeBody.querySelectorAll("div a");
                    if (iframeBannerElements && iframeBannerElements.length > 0) {
                        iframeBannerElements.forEach((item) => {
                            if (item) {
                                item.addEventListener('click', function () {
                                    logAdEventsInAmplitude('click');
                                });
                            }
                        });
                    }
                }
            }
        }
    } catch (e) {
        // Error handled silently for security
    }
}

const logKeyValueForAds = () => {
    try {
        let keyValues = {};
        if (window && window.location.pathname) {
            keyValues['CP'] = window.location.pathname.split("/").pop().split('.')[0];
            keyValues['URL'] = window.location.pathname.replace(/\//g, '-');
        }
        CookieService.getCookie("WULanguageCookie_") && (keyValues['LG'] = CookieService.getCookie("WULanguageCookie_"));
        CookieService.getCookie("userIdentity") && (keyValues['VT'] = CookieService.getCookie("userIdentity"));
        CookieService.getCookie("utm_source") && (keyValues['UTMS'] = CookieService.getCookie("utm_source"));
        CookieService.getCookie("utm_campaign") && (keyValues['UTMC'] = CookieService.getCookie("utm_campaign"));
        CookieService.getCookie("utm_medium") && (keyValues['UTMM'] = CookieService.getCookie("utm_medium"));
        
        for (const [key, value] of Object.entries(keyValues)) {
            value && googletag.pubads().setTargeting(key, value);
        }
    } catch (e) {
        // Error handled silently for security
    }   
}

const consentForNonPersonalizedAds = (googleAdPageData) => {
    return googleAdPageData?.personalizedAdCookies ? isNonPersonalizedAd(googleAdPageData.personalizedAdCookies) : false;
}
